export default "__VITE_ASSET__BVj7ILMh__"